import { FormErrorBoundary, FormErrorBoundaryMode, InputComponentType, OmitInputProps } from '@ngt/forms-core';
import React, { ComponentProps, ComponentType, ReactNode } from 'react';
import Field, { IFieldProps } from '../Field';
import Input, { IInputProps } from '../../inputs/Input';

type OmitProps<T> = Omit<T, 'propertyPath'>;

interface IFieldOnlyProps<TValue = any> extends OmitProps<IFieldProps<TValue>> {
    errorMode?: FormErrorBoundaryMode;
}

export interface IInputOnlyFieldProps<
    TComponent extends InputComponentType = any,
    TValue = any,
    TForm extends object = any
    > extends IInputProps<TComponent, TValue> {
    propertyPath: string;
    FieldProps?: IFieldOnlyProps<TValue>;
    WrappingComponent?: ComponentType<{children?: ReactNode; }>;
}

const InputOnlyField = <
    TComponent extends InputComponentType = any,
    TValue = any
>({
    propertyPath,
    FieldProps: { errorMode = FormErrorBoundaryMode.Contain, ...fieldProps } = { errorMode: FormErrorBoundaryMode.Contain },
    WrappingComponent,
    ...props
}: IInputOnlyFieldProps<TComponent, TValue> & Partial<OmitInputProps<ComponentProps<TComponent>>>) => {

    let internal = <Input {...props} />;

    if (WrappingComponent) {
        internal = <WrappingComponent>
            {internal}
        </WrappingComponent>
    }

    return (
        <FormErrorBoundary mode={errorMode}>
            <Field propertyPath={propertyPath} {...fieldProps}>
                {internal}
            </Field>
        </FormErrorBoundary>
    )
};

export default InputOnlyField;